// Central API base URL.
// Override at build time via the REACT_APP_API_URL env var (see .env).
// Falls back to UAT if nothing is set.
const API_URL =
  process.env.REACT_APP_API_URL || "https://uat.networking.cognisun.net:4015/";

export default API_URL;
